
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, Copy, Maximize, 
  Settings, Save, Download, Share2 
} from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ResultsHeaderProps {
  copyAllPrompts: () => void;
  hasPrompts: boolean;
  saveSession: () => void;
  toggleFullscreen: () => void;
  isFullscreen: boolean;
}

const ResultsHeader = ({ 
  copyAllPrompts, 
  hasPrompts, 
  saveSession, 
  toggleFullscreen,
  isFullscreen 
}: ResultsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="border-b border-white/10 backdrop-blur-md bg-gray-900/80 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button 
            onClick={() => navigate('/')}
            variant="ghost" 
            size="sm"
            className="flex items-center gap-2 hover:bg-secondary/50"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Back</span>
          </Button>
          
          <div className="h-6 w-px bg-white/10"></div>
          
          <h1 className="text-lg font-medium">
            <span className="font-display bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent">
              PromptAssist
            </span>
          </h1>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            onClick={toggleFullscreen}
            variant="outline" 
            size="sm"
            className="flex items-center gap-1 bg-secondary/50 border-white/10 hover:bg-secondary text-sm"
          >
            <Maximize className="h-3.5 w-3.5" />
          </Button>
          
          <Button 
            onClick={saveSession}
            variant="outline" 
            size="sm"
            className="flex items-center gap-1 bg-secondary/50 border-white/10 hover:bg-secondary text-sm"
          >
            <Save className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Save</span>
          </Button>
          
          <Button 
            onClick={copyAllPrompts}
            variant="outline" 
            size="sm"
            className="flex items-center gap-1 bg-secondary/50 border-white/10 hover:bg-secondary text-sm"
            disabled={!hasPrompts}
          >
            <Download className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Export</span>
          </Button>
          
          <Button 
            variant="outline" 
            size="sm"
            className="flex items-center gap-1 bg-secondary/50 border-white/10 hover:bg-secondary text-sm"
          >
            <Share2 className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Share</span>
          </Button>
          
          <Button 
            variant="outline" 
            size="sm"
            className="flex items-center gap-1 bg-secondary/50 border-white/10 hover:bg-secondary text-sm"
          >
            <Settings className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </header>
  );
};

export default ResultsHeader;
